// extracted by css-extract-rspack-plugin
export default {"root":"G2RIVy","compact":"t89nYy","extras":"hgjqHh"};